import { useQuery } from '@tanstack/react-query'
import axios, { AxiosError } from 'axios'
import { Dashboard } from '../admin/pages/dashboard/types'

export interface DashboardConfigResponse {
  dashboard_id: number
  name: string
  description: string
  competition_id: number | null
  config: Dashboard
}

export async function getCompetitionDashboard(
  competitionId: number
): Promise<DashboardConfigResponse | null> {
  try {
    const res = await axios.get(`/api/competitions/${competitionId}/dashboard`)
    return res.data
  } catch (e) {
    if (e instanceof AxiosError && e.response?.status === 404) {
      return null
    }
    throw e
  }
}

export function useCompetitionDashboard(competitionId: number) {
  return useQuery({
    queryKey: ['competition-dashboard', competitionId],
    queryFn: () => getCompetitionDashboard(competitionId),
    staleTime: 60 * 1000,
    enabled: !!competitionId,
  })
}

export async function getDashboardById(
  dashboardId: number
): Promise<DashboardConfigResponse | null> {
  try {
    const res = await axios.get(`/api/dashboards/${dashboardId}/config`)
    return res.data
  } catch (e) {
    if (e instanceof AxiosError && e.response?.status === 404) {
      return null
    }
    throw e
  }
}

export function useDashboardById(dashboardId: number) {
  return useQuery({
    queryKey: ['dashboard-by-id', dashboardId],
    queryFn: () => getDashboardById(dashboardId),
    staleTime: 60 * 1000,
    enabled: !!dashboardId,
  })
}

export async function getDeviceDashboardConfig(): Promise<DashboardConfigResponse | null> {
  const res = await axios.get('/api/device-link/dashboard/current/config')
  return res.data
}

export function useDeviceDashboardConfig() {
  return useQuery({
    queryKey: ['device-dashboard-config'],
    queryFn: getDeviceDashboardConfig,
    staleTime: 60 * 1000,
  })
}
